import NavUserProfileDropDown from "./NavUserProfileDropDown";
import Form from "olive-react-myoneui/lib/Form";
import {
	bellIcon,
	cartIcon,
	cartIcon101,
	menuHamburgerIcon,
	envelopeIcon,
	searchIcon,
	bundleIcon
} from "../constants/icons";
import OffcanvasNavMenu from "./OffcanvasNavMenu";
import { useState, useEffect } from "react";
import LinkWrapper from "./LinkWrapper";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Dropdown } from "olive-react-myoneui";
import OffcanvasMessages from "./student-dashboard/OffcanvasMessages";
import OffcanvasNotification from "./student-dashboard/OffcanvasNotification";
import { setCart } from "../reducers/cartSlice";
import DropdownNavItem from "./student-dashboard/DropdownNavItem";
import { useTranslation } from "react-i18next";
import RedirectURLObject from "./RedirectURLObject";
import axios from 'axios'
import { commonModuleName } from "../constants/config";
import SearchCourseBlock from "../components/student-dashboard/search-course-list/SearchCourseBlock";
import SearchCourseList from "./student-dashboard/search-course-list/SearchCourseList";
import { getCache } from "./Page/utils/cacheManager";
import { getAllCourses } from "../api/initialApis";

function NavigationBarStudentLanding() {
	const { t } = useTranslation(commonModuleName);
	let searchTimer;
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const location = useLocation();
	const [activeLink, setActiveLink] = useState(location.pathname);
	const website = useSelector((state) => state.user.website);
	const paths = useSelector((state) => state.user.paths);
	const [logoPath, setLogoPath] = useState(null);
	const [messageCount, setMessageCount] = useState(null);
	const headerMenus = useSelector((state) => state.user.headerMenus);
	const loggedInUser = useSelector((state) => state.user.user);
	const miscellaneous = useSelector((state) => state.user.miscellaneous);
	const [menuActive, setMenuActive] = useState(false);
	const nonReactMenus = ["document_manager"];
	const cartUrlObject = RedirectURLObject({ type: "cart" });
	const LoginUrl = RedirectURLObject({ type: "login" });
	const [notificationcount, setNotificationCount] = useState();

	let cart = useSelector((state) =>  localStorage.getItem('mycart_count') ?? state.cart.cartCount); 
	// Mobile show Show hide content Search and Cart

	const [isSearchActive, setIsSearchActive] = useState(false);
	const [isCartActive, setIsCartActive] = useState(false);
	const [allCourses, setAllCourses] = useState([]);

	

	const handleSearchClick = () => {
		setIsSearchActive(!isSearchActive);
		setIsCartActive(false);
	};

	const handleCartClick = () => {
		setIsCartActive(!isCartActive);
		setIsSearchActive(false);
	};

	useEffect(() => {
		if (isSearchActive) {
			document.body.classList.add('search-course-active');
		} else {
			document.body.classList.remove('search-course-active');
		}
	}, [isSearchActive]);
	
	useEffect(()=>{

		getCache("all_courses", getAllCourses, {}, 2592000).then(content=>{
			setAllCourses(content);
			// console.log("all courses",content)
		}).catch( err =>{
			console.log(err)
		})
		
		  
	},[getAllCourses])

	// Mobile show Show hide content Search and Cart

	// cart = localStorage.getItem('mycart_count')
	// console.log(loggedInUser.logged_in_user.id)
	useEffect(() => {
		if (website.header) {
			setHeaderColor();
			window.addEventListener("scroll", () => {
				if (!document.querySelector(".sticky-top") || !website.header) return false;
				setHeaderColor();
			});
		}
	}, [website]);

	useEffect(() => {
		const host = window.location.hostname
		let url;
		if(loggedInUser.is_logged_in){
			
		
			if (loggedInUser.is_logged_in == "admin") {
				url = `https://${host}/admin/dashboard/notification_count`
			}
			else {
				url = `https://${host}/dashboard/notification_count`
			}
			axios.get(`${url}`, {
			})
				.then((response) => {
					setNotificationCount(response.data.count)
					// console.log(response.data.count)
				});
		}
	}, []);

	useEffect(() => {
		var user = {
			"userId": loggedInUser.logged_in_user.id
		}
		axios.post(`${paths.message_api_url}getmessagecount`, user, {
			headers: {
				'Authorization': `Bearer ${loggedInUser.logged_in_user.token}`
			}
		})
			.then((res) => {
				setMessageCount(res?.data?.count)
				// console.log(response.data.count)
			});
	}, [paths.message_api_url]);



	const navDropDownClick = (obj) => {
		if (obj.mm_connected_as_external == "1") {
			if (obj.mm_new_window == "1") window.open(obj.mm_external_url, "_blank");
			else window.location.href = obj.mm_external_url;
			return false;
		}
		navigate("/" + obj.mm_item_connected_slug);
	}

	const navCategoryClick = (obj) => {
		if (obj.id == '0') navigate("/course/listing");
		else navigate("/course/listing?categoryids=" + obj.id);
	}

	const setHeaderColor = () => {
		if (document.querySelector(".sticky-top") && document.querySelector(".top-header-wrapper") && document.querySelector(".top-header-wrapper").offsetHeight + (document.querySelector("#notificationBar") ? document.querySelector("#notificationBar").offsetHeight : 0) < document.querySelector(".sticky-top").offsetTop) {
			if (website.header.main_nav.scrolling_background_color) document.documentElement.style.setProperty('--db-main-header-bg', website.header.main_nav.scrolling_background_color);
			if (website.header.main_nav.scrolling_text_color) document.documentElement.style.setProperty('--db-main-header-tc', website.header.main_nav.scrolling_text_color);
		} else {
			if (website.header.main_nav.background_color) document.documentElement.style.setProperty('--db-main-header-bg', website.header.main_nav.background_color);
			if (website.header.main_nav.text_color) document.documentElement.style.setProperty('--db-main-header-tc', website.header.main_nav.text_color);
		}
	}

	useEffect(() => {
		setActiveLink(location.pathname);
	}, [location.pathname]);


	useEffect(() => {
		setLogoPath(paths.logo_path + website.site_logo);
	}, [paths, website]);

	const onHamburgerClick = (e) => {
		const body = document.body;
		if (body.classList.contains("menu-active")) {
			body.classList.remove("menu-active");
			setMenuActive(false);
		} else {
			body.classList.add("menu-active");
			setMenuActive(true);
		}
	};

	const onViewSiteClick = (e) => {
		e.preventDefault();
		// window.location.assign(headerData.site_url);
	};

	const inputSearch = () => {
		clearTimeout(searchTimer);
		searchTimer = setTimeout(() => {
			submitSearch();
		}, 1000);
	}

	const submitSearch = (e = null) => {
		if (e) {
			e.preventDefault();
		}
		setTimeout(() => {
			const searchInput = document.getElementById("searchId").value;
			if (searchInput == "") {
				clearSearch();
				return false;
			}
			let currentURLSearch = Object.fromEntries(
				new URLSearchParams(window.location.search)
			)
			currentURLSearch.search = searchInput;
			navigate("/course/listing?" + new URLSearchParams(currentURLSearch));
		}, 500);
	}

	const clearSearch = () => {
		document.getElementById("searchId").value = '';
		let searchObject = Object.fromEntries([...searchParams]);
		if (searchObject['search']) delete searchObject['search']
		setSearchParams({ ...searchObject });
	}
	// if (!apiLoaded) {
	// return null;
	// }
	return (
		<>
			<nav className={"navbar navbar-expand-lg navbar-student-dashboard navbar-student-landing backdrop-filter custom-landing-navbar" + (website.header_fixed == 1 ? " sticky-top" : "") + (searchParams.get('privacy') === "" ? " d-none" : "")}>
				<div className="container-fluid">
					<div className="logo-toggle-wrapper d-flex align-items-center gap-3">
						<div
							className="mobile-menu d-flex gap-2 d-xl-none"
							onClick={onHamburgerClick}
						>
							<span className="sidebar-toggle">
								{menuActive ? menuHamburgerIcon : menuHamburgerIcon}
							</span>
						</div>
						<LinkWrapper className="navbar-brand" href="/" isReact={true}>
							<img src={logoPath} className="img-fluid" alt="Logo" />
						</LinkWrapper>
					</div>
					<div
						className="collapse navbar-collapse justify-content-between"
						id="navbarSupportedContent"
					>
						<ul className="navbar-nav mb-lg-0 d-flex gap-4 main-navigation ms-3">
							{
								headerMenus.menu_pages && Object.keys(headerMenus.menu_pages).length > 0 &&
								Object.keys(headerMenus.menu_pages).map((key, index) => {
									const currentMenu = headerMenus.menu_pages[key];
									let isReact = true;
									if (currentMenu.is_default == '1' && currentMenu.mm_name.toLowerCase() == "categories" && headerMenus.categories.length > 0) {
										return (<li key={"headerMenu_" + key} className="nav-item">
											<DropdownNavItem items={[{ id: '0', ct_name: "all" }, ...headerMenus.categories]} nameIndex="ct_name" label={currentMenu.mm_name} onChange={(obj) => navCategoryClick(obj)} className="mb-0" />
										</li>)
									}
									if (currentMenu.child?.length > 0) {
										return (<li key={"headerMenu_" + key} className="nav-item">
											<DropdownNavItem items={currentMenu.child} nameIndex="mm_name" label={currentMenu.mm_name} onChange={(obj) => navDropDownClick(obj)} className="mb-0" />
										</li>)
									}
									if (currentMenu.mm_connected_as_external == "1") {
										return (<li key={"headerMenu_" + key} className="nav-item">
											<LinkWrapper isReact={false} href={currentMenu.mm_external_url} className="nav-link" newWindow={currentMenu.mm_new_window == "1" ? true : false}>
												{t(currentMenu.mm_name)}
											</LinkWrapper>
										</li>)
									}
									isReact = !nonReactMenus.includes(currentMenu.mm_item_connected_slug);
									return (<li key={"headerMenu_" + key} className="nav-item">
										<LinkWrapper isReact={isReact} href={"/" + currentMenu.mm_item_connected_slug} className={"nav-link" + (activeLink == "/" + currentMenu.mm_item_connected_slug ? " active" : "")} >
											{t(currentMenu.mm_name)}
										</LinkWrapper>
									</li>
									)
								})
							}
						</ul>
						<div className="navbar-wrapper d-flex align-items-center mk-gap-28px flex-grow-1 justify-content-end">
							<Form.Group className="search-wrapper" controlId="searchId">
								<Form onSubmit={(e) => submitSearch(e)}>
									<Form.Control
										type="search"
										placeholder={t("search_course_name") + "..."}
										autoComplete="off"
										defaultValue={searchParams.get('search')}
										onInput={inputSearch}
										className="custom-search-input"
									/>
									<span className="search-icon">
										{searchIcon}
									</span>
									<span className="btn-clear" onClick={clearSearch}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="26"
											height="26"
											viewBox="0 0 26 26"
										>
											<g id="close" data-name="close" transform="translate(-1137 -293)">
												<rect
													id="Rectangle_753"
													data-name="Rectangle 753"
													width="26"
													height="26"
													rx="13"
													transform="translate(1137 293)"
													fill="#f7f8fa"
												/>
												<g
													id="Group_17821"
													data-name="Group 17821"
													transform="translate(1147.027 303.027)"
												>
													<path
														id="Path_21632"
														data-name="Path 21632"
														d="M0,0V8.41"
														transform="translate(5.947 0) rotate(45)"
														fill="none"
														stroke="#13171f"
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth="1.7"
													/>
													<path
														id="Path_21633"
														data-name="Path 21633"
														d="M0,0V8.41"
														transform="translate(5.947 5.947) rotate(135)"
														fill="none"
														stroke="#13171f"
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth="1.7"
													/>
												</g>
											</g>
										</svg>
									</span>
								</Form>
							</Form.Group>
							<div className="ui-nav-divider"></div>
							{
								!loggedInUser.is_logged_in && (
									<>
										{miscellaneous.shopping_cart && (
											<ul className="navbar-nav navbar-icons mb-lg-0 d-flex">
												<li className="nav-item">
													<LinkWrapper isReact={cartUrlObject.isReact} className="nav-link" href={cartUrlObject.url}>
														{cartIcon}
														<span className="notitication-alert">{cart}</span>
													</LinkWrapper>
												</li>
											</ul>
										)}
										<Button
											onClick={() => { window.location.href = LoginUrl.url }}
											variant="primary"
											className="bg-user-color top-header-tc"
										>
											{t('login')}
										</Button>
									</>
								)
							}
							{
								loggedInUser.is_logged_in && (
									<>
										<ul className="navbar-nav navbar-icons mb-lg-0 d-flex">
											<li className="nav-item">
												<OffcanvasMessages triggerTitle={envelopeIcon} messageCount={messageCount} setMessageCount={setMessageCount} />
											</li>
											<li className="nav-item">
												<a className="nav-link">
													<OffcanvasNotification triggerTitle={bellIcon} notificationcount={notificationcount} setNotificationCount={setNotificationCount} />
												</a>
											</li>
											{
												miscellaneous.shopping_cart &&
												<li className="nav-item">
													<LinkWrapper isReact={cartUrlObject.isReact} className="nav-link" href={cartUrlObject.url}>
														{cartIcon}
														<span className="notitication-alert">{cart}</span>
													</LinkWrapper>
												</li>
											}
											{/* <li className="nav-item">
												<OffcanvasMessages triggerTitle={envelopeIcon} />
											</li> */}
										</ul>
										<NavUserProfileDropDown />
									</>
								)
							}
						</div>
					</div>
					<div className="mobile-menu d-flex align-items-center gap-2 res-mobile-icons">
						<span className={`nav-link mobile-view-icon ${isSearchActive ? 'active' : ''}`} onClick={handleSearchClick}>
							{searchIcon}
						</span>
						{/* {miscellaneous.guest_checkout && miscellaneous.shopping_cart && ( */}
							<ul className="navbar-nav mb-0 mb-lg-0 d-flex align-items-center justify-content-end flex-row gap-3">
								<li className="nav-item">
									<a className="nav-link" href="#">
										<OffcanvasNotification triggerTitle={bellIcon} />
									</a>
								</li>
								<li className="nav-item">
									<LinkWrapper isReact={cartUrlObject.isReact} className="nav-link" href={cartUrlObject.url}>
										{cartIcon}
										<span className="notitication-alert">{cart}</span>
									</LinkWrapper>
								</li>
							</ul>
						{/* )} */}
						{
							loggedInUser.is_logged_in && (
								<>

									<Button
										onClick={() => { window.location.href = LoginUrl.url }}
										variant="primary"
										className="w-100 bg-user-color login-btn"
										size="sm"
									>
										Login
									</Button>
								</>
							)
						}
						<ul className="navbar-nav mb-0 mb-lg-0 d-flex align-items-center justify-content-end flex-row gap-3">
							{
								loggedInUser.is_logged_in && (
									<>
										<li className="nav-item m-0 res-nav-item-hide">
											<a className="nav-link" aria-current="page" href="#top">
												{envelopeIcon}
											</a>
										</li>
										<li className="nav-item m-0 res-nav-item-hide">
											<a className="nav-link" aria-current="page" href="#top">
												{bellIcon}
											</a>
										</li>
										{
											miscellaneous.shopping_cart &&
											<li className="nav-item res-nav-item-hide">
												<LinkWrapper isReact={cartUrlObject.isReact} className="nav-link" href={cartUrlObject.url}>
													{cartIcon}
													<span className="notitication-alert">{cart}</span>
												</LinkWrapper>
											</li>
										}
									</>
								)
							}
						</ul>
					</div>
				</div>
				<OffcanvasNavMenu loggedInUser={loggedInUser} headerMenus={headerMenus} />

			</nav>

			{isSearchActive && (
				<SearchCourseBlock>
					{allCourses.map(item =>{
						return <SearchCourseList
						key={item.item_id}
						imageSrc={item.item_full_image}
						bundleIcon={bundleIcon}
						title={item.item_name}
						currentPrice={`₹${item.item_price}`}
						originalPrice={`₹${item.item_discount}`}
						memberPrice={item.member_price}
						priceShowLabel = {item.item_price_label_show}
						itemType = {item.item_type}
						itemCourseCount = {item.item_course_count}
						bundleText="1 in 1" />
					})}
					{/* <SearchCourseList
						imageSrc="https://d2cl07xv2ii8xi.cloudfront.net/uploads/saas.sandbox.mykademy.com/items_org/course/8.webp?v=29"
						bundleIcon={bundleIcon}
						title="Social media marketing & digital marketing course 2018"
						currentPrice="₹1999"
						originalPrice="₹2299"
						memberPrice="₹1600"
						bundleText="1 in 1" /> */}
					{/* <SearchCourseList
						imageSrc="https://d2cl07xv2ii8xi.cloudfront.net/uploads/saas.sandbox.mykademy.com/items_org/course/7.webp?v=34"
						bundleIcon={bundleIcon}
						title="What is Social Engineering | Attack Techniques & Prevention"
						currentPrice="₹1500"
						originalPrice="₹1900"
						memberPrice="₹1920"
						bundleText="3 in 1" /> */}
				
				</SearchCourseBlock>
			)}
		</>
	);
}

export default NavigationBarStudentLanding;